const AppDefaults = {
    formates: {
        date: "DD/MM/YYYY",
        datetime: "DD/MM/YYYY HH:mm A",
        _date:"DD-MM-YYYY",
        standredUTCDate:"YYYY-MM-DD",
        standredUTCTime:"YYYY-MM-DD HH:MM:SS",
        time:"hh:mm A",
        timeFormat:"HH:mm:ss"
    },
    DECIMAL_MAX_ALLOWED:9999999999999999.99,
    POS_DECIMAL_MAX_ALLOWED:9999999999999999.99,
    SIXTEEN_DECIMAL_ALLOWED:9999999999999999.99,
    CRYPTO_DECIMALS:9999999999999999.99999999,
    GUID_ID:'00000000-0000-0000-0000-000000000000'
}
export default AppDefaults;